import { CurveBuildBase } from './base/curve-build-base';

export class CurveBuild extends CurveBuildBase { }